import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Calendar, RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DashboardFiltersProps {
  period: string;
  onPeriodChange: (period: 'today' | 'week' | 'month' | 'year') => void;
  onReset: () => void;
}

export function DashboardFilters({
  period,
  onPeriodChange,
  onReset,
}: DashboardFiltersProps) {
  const { t } = useTranslation("dashboard");

  return (
    <div className="flex items-center gap-2 sm:gap-3 bg-card border rounded-lg p-2 sm:p-3 sticky top-0 z-10 shadow-sm">
      <div className="flex items-center gap-2 flex-1">
        <Calendar className="h-4 w-4 text-muted-foreground hidden sm:block" />
        <Select value={period} onValueChange={onPeriodChange}>
          <SelectTrigger className="w-[140px] sm:w-[180px]">
            <SelectValue placeholder={t("filters.selectTimeframe")} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="today">
              {t("filters.daily")}
            </SelectItem>
            <SelectItem value="week">
              {t("filters.weekly")}
            </SelectItem>
            <SelectItem value="month">
              {t("filters.monthly")}
            </SelectItem>
            <SelectItem value="year">
              {t("filters.yearly")}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <Button
        variant="outline"
        size="sm"
        onClick={onReset}
        className="flex items-center gap-2"
      >
        <RotateCcw className="h-4 w-4" />
        <span className="hidden sm:inline">{t("filters.reset")}</span>
      </Button>
    </div>
  );
}
